module.exports = {"base":{"hex":"#ffffff","hsl":{"h":150,"s":0,"l":1,"a":1},"hsv":{"h":150,"s":0,"v":1,"a":1},"rgba":{"r":255,"g":255,"b":255,"a":1},"a":1},"main":{"hex":"#F2F2F2","hsl":{"h":150,"s":0,"l":0.9490196078431372,"a":1},"hsv":{"h":150,"s":0,"v":0.9490196078431372,"a":1},"rgba":{"r":242,"g":242,"b":242,"a":1},"a":1},"accent":{"hex":"#C8161E","hsl":{"h":357.30337078651684,"s":0.8018018018018017,"l":0.43529411764705883,"a":1},"hsv":{"h":357.30337078651684,"s":0.89,"v":0.7843137254901961,"a":1},"rgba":{"r":200,"g":22,"b":30,"a":1},"a":1}}


//////////////////
// WEBPACK FOOTER
// ./src/api/app-colors.json
// module id = 241
// module chunks = 153